import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import BarraDeInformacoes from './components/BarraDeInformacoes';
import StatsContainer from './components/StatsContainer';
import Plans from './Plans';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import RHSection from './components/RHSection';
import PurposeBanner from './components/PurposeBanner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />

      <main>
        <h1>Bem-vindo à Nação Saúde</h1>
        <p>Aqui você pode conhecer nossos planos, rede credenciada e muito mais.</p>
        <BarraDeInformacoes />
        <StatsContainer />
        <Plans />
        <Testimonials />
        <RHSection />
        <PurposeBanner />
      </main>

      <Footer />
    </div>
  );
}

export default App;
